/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Wl_SendingInputs */

const en_st_wl_sending = /** @type {(inputs: St_Wl_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending…`)
};

const id_st_wl_sending = /** @type {(inputs: St_Wl_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengirim…`)
};

/**
* | output |
* | --- |
* | "Sending…" |
*
* @param {St_Wl_SendingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_wl_sending = /** @type {((inputs?: St_Wl_SendingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Wl_SendingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_wl_sending(inputs)
	return en_st_wl_sending(inputs)
});